import { useQueryClient } from '@tanstack/react-query'
import { deleteConsignmentItemV2 } from '../api/http'
import getConsignmentItemSuccessHandlers from './consignmentItemSuccessHandlers'

function useDeleteConsignmentItem(consignmentId: number, houseConsignmentId: number) {
  const queryClient = useQueryClient()
  const { onDeleteSuccess } = getConsignmentItemSuccessHandlers(queryClient, consignmentId, houseConsignmentId)

  const deleteConsignmentItem = async (consignmentItemId: number) => {
    await deleteConsignmentItemV2(consignmentItemId)
    await onDeleteSuccess(undefined, consignmentItemId)
  }

  return {
    deleteConsignmentItem,
  }
}

export default useDeleteConsignmentItem
